import { PageController } from '@client/components/_core/layout/PageController';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { RiskActionPlanEdit } from '../../RiskActionPlan/RiskActionPlanEdit';

// The repeated `action-plan` segment is load-bearing: the pre-CUR-868 dynamic route rendered
// this drawer at /details/$id/action-plan/action-plan/add, and that exact shape is what past
// notification emails link to — do not "clean up" the URL without a redirect from the old one.
export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/action-plan/action-plan/add')({
    staticData: {
        presentation: 'overlay',
        ui: { useParentTitle: true },
    },
    component: RiskActionPlanAddRoute,
});

function RiskActionPlanAddRoute() {
    const { id: riskId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <RiskActionPlanEdit
                action={['add']}
                riskId={riskId}
                onClose={async () => {
                    await trpcUtils.risk.actionPlan.invalidate();
                    navigate({
                        to: '/console/$orgId/risk/register/details/$id/action-plan',
                        params: { orgId, id: riskId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
